const ROLE_LABELS = {
  admin: 'Administrator',
  pentester: 'Pentester',
  asset_owner: 'Asset Owner',
  client: 'Client',
  workspace_admin: 'Workspace Administrator'
};

function getRoleLabel (name) {
  if (!name) return '';
  if (ROLE_LABELS[name]) return ROLE_LABELS[name];
  return name.replace(/[-_]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

export default getRoleLabel;
